export default function (el) {
  if (el === null) return false;

  document
    .getElementById('nzBlogCategorySelect')
    .addEventListener('change', function () {
      const selectedCategory = this.value;
      const container = document.getElementById('blogPostsContainer');

      container.innerHTML = `<div id="request-loading-spinner" class="request-spinner-container">
	                            <div class="request-spinner"></div>
                            </div>`;

      fetch(`/blog/filter-posts?category=${selectedCategory}`)
        .then((response) => response.text())
        .then((html) => {
          container.innerHTML = html;
        });
    });
}
